import React from 'react'
// import { FaGithub } from 'react-icons/fa'
import './Footer.css'

const Footer = () => {
    return (
        <div className="footer">
            <p> Build with 💙 & ☕️ by Viktoriia Zolotova 2023</p>
            <div>
                {/* <a
                    className="footer-link"
                    href="https://github.com/viktoriiazolotova/"
                    target="_blank"
                    rel="noreferrer"
                >
                    {<FaGithub size={25} />}
                </a> */}
            </div>
        </div>
    )
}

export default Footer
